"use client"

import { MemberListTitleProps } from "@/types/types"

export const MemberListTitle = ({ title, description }: MemberListTitleProps) => {
  return title || description ? (
    <div className="px-[0.9375rem] sm:px-0 mb-8 sm:mb-15">
      {title && (
        <h2 className="text-xl sm:text-2xl font-black text-center mb-4 md:mb-6 leading-[1.625rem] text-[#212529] uppercase">
          {title}
        </h2>
      )}
      {description && (
        <p className="text-sm sm:text-lg font-normal leading-[1.75rem] text-center sm:w-[630px] text-[#333333] max-w-4xl mx-auto">
          {description}
        </p>
      )}
    </div>
  ) : null
}
